<template>
    <section class="home-possible-earnings">
        <div class="home-possible-earnings__container">
            <div class="home-possible-earnings__title">
                <plugin-home-common-title text="Сколько Вы могли бы заработать" />
            </div>
            <div class="home-possible-earnings__content">
                <div class="home-possible-earnings__calc">
                    <div class="home-possible-earnings__sum">
                        <div class="home-possible-earnings__sum-titles">
                            <div class="home-possible-earnings__sum-left">
                                Сумма вложений
                            </div>
                            <div class="home-possible-earnings__sum-right">
                                Мин. сумма - 100 000 ₽
                            </div>
                        </div>
                        <div class="home-possible-earnings__sum-value">
                            {{ rangeValueFormatted }} ₽
                        </div>
                    </div>

                    <div class="home-possible-earnings__range">
                        <plugin-home-possible-earnings-range-5 v-model="rangeValue" />
                    </div>

                    <div class="home-possible-earnings__result">
                        <div class="home-possible-earnings__result-today">
                            <div class="home-possible-earnings__result-today-title">Капитал сегодня</div>
                            <div class="home-possible-earnings__result-today-value"
                                 v-bind:class="{ _hide: !capitalTodayFormatted }"
                            >
                                {{ capitalTodayFormatted}} ₽
                            </div>
                        </div>
                        <div class="home-possible-earnings__result-period">
                            <div class="home-possible-earnings__result-period-title">Прибыль за период</div>
                            <div class="home-possible-earnings__result-period-value"
                                 v-bind:class="{ _hide: !periodProfitFormatted }"
                            >
                                {{ periodProfitFormatted }} ₽
                            </div>
                        </div>
                    </div>

                    <div class="home-possible-earnings__disclaimer">
                        Доходность в прошлом не гарантирует доходность в будущем.
                    </div>

                    <div class="home-possible-earnings__button">
                        <ui-button
                            v-bind:href="loginUrl"
                            theme="primary"
                            size="huge"
                            v-bind:is-uppercase="false"
                            is-width-free
                        >
                            Начать инвестировать
                        </ui-button>
                    </div>
                </div>

                <div class="home-possible-earnings__graph">
                    <plugin-home-possible-earnings-graph
                        v-bind:annual-indexes="annualIndexes"
                        v-bind:cumulative-indexes="cumulativeIndexes"
                        v-bind:categories="graphCategories"
                        v-bind:series="graphSeries"
                    />
                    <div class="home-possible-earnings__button-mobile">
                        <ui-button
                            v-bind:href="loginUrl"
                            theme="primary"
                            size="lg"
                            v-bind:is-uppercase="false"
                            is-width-free
                        >
                            Начать инвестировать
                        </ui-button>

<!--                        <div class="home-possible-earnings__disclaimer-mobile">
                            Доходность в прошлом не гарантирует доходность в будущем.
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import utils from '~/utils';
import config from '~/config';
import { mainClient } from '~/network';

export default {
    name: 'plugin-home-possible-earnings',
    data() {
        return {
            isLoading: false,
            error: null,
            rangeValue: 1000000,
            // capitalToday: null,
            // periodProfit: null,
            graphSeries: [],
            graphCategories: [],
            annualIndexes: [],
            cumulativeIndexes: [],
            totalReturnIndex: null,
            from: null,
            to: null,
            loginUrl: config.urls.auth.login,
        };
    },
    computed: {
        rangeValueFormatted() {
            return utils.formats.formatNumberWithSpaces(this.rangeValue);
        },
        years() {
            if (this.from !== null && this.to !== null) {
                const from = new Date(this.from);
                const to = new Date(this.to);

                const diffTime = Math.abs(to - from);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                return parseFloat((diffDays / 365.25).toFixed(4));
            }
            return null;
        },
        capitalToday() {
            if (this.totalReturnIndex !== null && this.years !== null) {
                return this.rangeValue * Math.pow(1 + this.totalReturnIndex, this.years);
            }
            return null;
        },
        capitalTodayFormatted() {
            if (this.capitalToday !== null) {
                return utils.formats.formatNumberWithSpaces(Math.floor(this.capitalToday));
            }
            return null;
        },
        periodProfit() {
            if (this.totalReturnIndex !== null) {
                return this.capitalToday - this.rangeValue;
            }
            return null;
        },
        periodProfitFormatted() {
            if (this.periodProfit !== null) {
                return utils.formats.formatNumberWithSpaces(Math.floor(this.periodProfit));
            }
            return null;
        },
    },
    methods: {
        /* eslint-disable */
        async getComparisonData() {
            this.error = null;
            this.isLoading = true;
            try {
                const { data, error } = await mainClient.benchmark.requests.getInvestmentComparison({
                    amount: this.rangeValue,
                    interval: 'quarter',
                });
                if (!error && data) {
                    this.totalReturnIndex = parseFloat(data?.summary?.annual_return) || null;
                    this.from = data?.from || null;
                    this.to = data?.to || null;
                    // this.capitalToday = parseInt(data?.summary?.capital_today, 10) || null;
                    // this.periodProfit = parseInt(data?.summary?.profit, 10) || null;

                    this.annualIndexes = data?.series?.map(s => Math.floor(parseFloat(s?.annual_return) * 100)) || [];
                    this.cumulativeIndexes = data?.series?.map((s) => {
                        if (s?.points?.length) {
                            const index = parseFloat(s.points[s.points.length - 1].index);
                            return Math.floor(index * 100) - 100;
                        }
                        return '';
                    }) || [];

                    data?.series?.forEach((item, index) => {
                        if (index === 0) {
                            this.graphCategories = item?.points?.map((point) => point.date) || [];
                        }
                        this.graphSeries.push({
                            name: item?.label,
                            data: item?.points?.map((point) => Math.floor(point.index * 100)) || [],
                        });
                    });
                }
            } catch (e) {
                this.error = 'Не удалось получить данные';
                console.error(e);
            }
            this.isLoading = false;
        },
        /* eslint-enable */
    },
    mounted() {
        this.getComparisonData();
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.home-possible-earnings {
    .container-landing();

    &__container {
        position: relative;
        margin: 0 auto;

        max-width: @landing-max-width;
        padding: 64px 48px;

        border: 1px solid @color-gray-light-secondary;
        border-radius: @border-radius-xxl;
        background-color: white;
    }

    &__content {
        display: grid;
        grid-template-columns: 380px 1fr;
        gap: 24px;
    }

    &__range {
        padding: 0 16px;
    }

    &__sum {
        max-width: 800px;
        margin: 0 auto;
        padding: 16px;
        border-radius: @border-radius-lg;
        background-color: @color-gray-lighter;
        border: 1px solid @color-gray-light-secondary;

        &-titles {
            .typography-heading();

            display: flex;
            justify-content: space-between;
            margin-bottom: 6px;
        }
        &-right {
            color: @color-gray-main;
        }
        &-value {
            .typography-medium();
        }
    }

    &__result {
        // display: grid;
        // grid-template-columns: 1fr 1fr;
        display: flex;
        flex-direction: column;
        gap: 12px;
        // margin: 36px 0;
        margin-top: 36px;
        margin-bottom: 12px;

        &-today,
        &-period {
            &-title {
                .typography-heading();

                margin-bottom: 4px;
                color: @color-gray-main;
            }
            &-value {
                font-size: 4.8rem;
                line-height: 5.4rem;
                font-weight: bold;

                &._hide {
                    visibility: hidden;
                }
            }
        }
        &-period {
            &-value {
                color: @color-primary;
            }
        }
    }

    &__button {

    }
    &__button-mobile {
        display: none;
        margin-top: 28px;
    }

    &__disclaimer-mobile,
    &__disclaimer {
        .typography-caption();

        margin-bottom: 40px;

        color: @color-gray-main;
    }
    &__disclaimer-mobile {
        display: none;
        margin-top: 22px;
        text-align: center;
    }

    @media (max-width: 1780px) {
        &__container {
            padding: 14px;
        }

        &__content {
            grid-template-columns: 1fr;
            gap: 0;
        }

        &__sum {
            padding: 12px;
            border-radius: @border-radius-md;

            &-titles {
                .typography-body();

                font-weight: bold;
            }
            &-value {
                .typography-small();

                font-weight: bold;
            }
        }

        &__result {
            flex-direction: row;
            justify-content: center;
            margin: 24px 0;

            &-today,
            &-period {
                min-width: 140px;

                &-title {
                    .typography-body();

                    font-weight: bold;
                }
                &-value {
                    .typography-large();

                    font-size: 24px;
                }
            }
            &-period {
                &-value {
                    color: @color-primary;
                }
            }
        }

        &__button {
            display: none;
        }
        &__button-mobile {
            display: flex;
            justify-content: center;
        }

        &__disclaimer {
            margin-top: 0;
            margin-bottom: 32px;
            text-align: center;
        }
        &__disclaimer-mobile {
            display: block;
        }
    }

    @media @media-md-down {

    }
}
</style>
